// #region Dependencias
import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Helmet } from 'react-helmet-async'
import { getPagesByURLRequest } from 'store/thunks/pagesThunks'
import Landing from 'components/Landing'
import { useTranslation } from 'react-i18next'
// #endregion

/**
 * Vista que renderiza el componente de landing page con la información de la
 * página seleccionada en modo de visualización.
 * @class
 * @module Pages
 */
const PageShow = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { i18n } = useTranslation()
  const { url } = useParams()
  const { paginaSeleccionada: pagina } = useSelector((state) => state.pages)

  /**
   * Hook useEffect para obtener la información de la página seleccionada
   * según la URL accedida mediante el thunk {@link getPagesByURLRequest}
   */
  useEffect(() => {
    dispatch(getPagesByURLRequest(url, navigate))
  }, [dispatch, navigate, url])

  /**
   * Renderiza el componente si ya se cargaron los datos de la página.
   */
  if (pagina.url) {
    return (
      <>
        <Helmet>
          <meta property="og:type" content="website" />
          <meta
            property="og:title"
            content={pagina.opciones[i18n.language].titulo}
          />
          <meta
            property="og:description"
            content={pagina.opciones[i18n.language].descripcion}
          ></meta>
          <meta
            property="og:image"
            content={pagina.secciones.hero[i18n.language].imagen}
          />
          <meta
            name="description"
            content={pagina.opciones[i18n.language].descripcion}
          />
          <meta
            name="keywords"
            content={pagina.opciones[i18n.language].keywords}
          />
          <meta name="language" content={i18n.language} />
          <title>{pagina.opciones[i18n.language].titulo}</title>
          {/* <!-- Google tag (gtag.js) --> */}
          {pagina.scripts.gtag && (
            <>
              <script
                async
                src={`https://www.googletagmanager.com/gtag/js?id=${pagina.scripts.gtag}`}
              ></script>
              <script>
                {`
                window.dataLayer = window.dataLayer || [];
                function gtagads() {
                  window.dataLayer.push(arguments);
                }
                gtagads('js', new Date());
                gtagads('config', '${pagina.scripts.gtag}');
              `}
              </script>
            </>
          )}
        </Helmet>
        <Landing valores={pagina} />
      </>
    )
  }
}

export default PageShow
